import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import { Segment } from '../geometry';
export var HachureIterator =
/*#__PURE__*/
function () {
  function HachureIterator(top, bottom, left, right, gap, sinAngle, cosAngle, tanAngle) {
    _classCallCheck(this, HachureIterator);

    this.deltaX = 0;
    this.hGap = 0;
    this.top = top;
    this.bottom = bottom;
    this.left = left;
    this.right = right;
    this.gap = gap;
    this.sinAngle = sinAngle;
    this.tanAngle = tanAngle;

    if (Math.abs(sinAngle) < 0.0001) {
      this.pos = left + gap;
    } else if (Math.abs(sinAngle) > 0.9999) {
      this.pos = top + gap;
    } else {
      this.deltaX = (bottom - top) * Math.abs(tanAngle);
      this.pos = left - Math.abs(this.deltaX);
      this.hGap = Math.abs(gap / cosAngle);
      this.sLeft = new Segment([left, bottom], [left, top]);
      this.sRight = new Segment([right, bottom], [right, top]);
    }
  }

  _createClass(HachureIterator, [{
    key: "nextLine",
    value: function nextLine() {
      if (Math.abs(this.sinAngle) < 0.0001) {
        if (this.pos < this.right) {
          var line = [this.pos, this.top, this.pos, this.bottom];
          this.pos += this.gap;
          return line;
        }
      } else if (Math.abs(this.sinAngle) > 0.9999) {
        if (this.pos < this.bottom) {
          var _line = [this.left, this.pos, this.right, this.pos];
          this.pos += this.gap;
          return _line;
        }
      } else {
        var xLower = this.pos - this.deltaX / 2;
        var xUpper = this.pos + this.deltaX / 2;
        var yLower = this.bottom;
        var yUpper = this.top;

        if (this.pos < this.right + this.deltaX) {
          while (xLower < this.left && xUpper < this.left || xLower > this.right && xUpper > this.right) {
            this.pos += this.hGap;
            xLower = this.pos - this.deltaX / 2;
            xUpper = this.pos + this.deltaX / 2;

            if (this.pos > this.right + this.deltaX) {
              return null;
            }
          }

          var s = new Segment([xLower, yLower], [xUpper, yUpper]);

          if (this.sLeft && s.intersects(this.sLeft)) {
            xLower = s.xi;
            yLower = s.yi;
          }

          if (this.sRight && s.intersects(this.sRight)) {
            xUpper = s.xi;
            yUpper = s.yi;
          }

          if (this.tanAngle > 0) {
            xLower = this.right - (xLower - this.left);
            xUpper = this.right - (xUpper - this.left);
          }

          var _line2 = [xLower, yLower, xUpper, yUpper];
          this.pos += this.hGap;
          return _line2;
        }
      }

      return null;
    }
  }]);

  return HachureIterator;
}();